// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { PICS_URL } from "../../api";
import { useStores } from "hooks/useStores";
import { getVideoEmbedUrl } from 'utils/videoUtils';
import Seo from 'components/Seo';

function UsefulComponent() {
  const [context, setContext] = useState({});
  const [isLoadedContext, setIsLoadedCoontext] = useState(false);
  const { api } = useStores()


  useEffect(() => {
      api.content.getPageApi("useful")
      .then((response) => {
        setContext(response.init_state.object);
        setIsLoadedCoontext(true);
      })
  }, []);

  const playVideo = () => {
    document.querySelector(".video1").style.display = "block";
    document.querySelector(".thumb1").style.display = "none";
  };

  const playVideo2 = () => {
    document.querySelector(".video2").style.display = "block";
    document.querySelector(".thumb2").style.display = "none";
  };

  const playVideo3 = () => {
    document.querySelector(".video3").style.display = "block";
    document.querySelector(".thumb3").style.display = "none";
  };

  const [videoUrls, setVideoUrls] = useState({
    economy: null,
    buy: null,
    select: null
  });

  useEffect(() => {
    if (isLoadedContext) {
      if (context.economy_video !== null) {
        setVideoUrls(prev => ({
          ...prev,
          economy: getVideoEmbedUrl(context.economy_video.video)
        }));
      }
      if (context.buy_video !== null) {
        setVideoUrls(prev => ({
          ...prev,
          buy: getVideoEmbedUrl(context.buy_video.video)
        }));
      }
      if (context.select_video !== null) {
        setVideoUrls(prev => ({
          ...prev,
          select: getVideoEmbedUrl(context.select_video.video)
        }));
      }
    }
  }, [isLoadedContext]);

  const [tabs, setTabs] = useState();
  const [tabsPages, setTabsPages] = useState();
  const [tabPage1, setTabPage1] = useState(true);
  const [tabPage2, setTabPage2] = useState(false);
  const [tabPage3, setTabPage3] = useState(false);

  useEffect(() => {
    setTabs(document.querySelectorAll(".usefulPage-tabs__item"));
    setTabsPages(document.querySelectorAll(".usefulPage-tabPage"));
  }, []);

  const tab1 = () => {
    for (let tab of tabs) {
      tab.classList.remove("usefulPage-tabs__item-active");
    }
    for (let tabsPage of tabsPages) {
      tabsPage.style.display = "none";
    }
    setTabPage1(true);
    setTabPage2(false);
    setTabPage3(false);
    tabs[0].classList.add("usefulPage-tabs__item-active");
    tabsPages[0].style.display = "block";
  };
  const tab2 = () => {
    for (let tab of tabs) {
      tab.classList.remove("usefulPage-tabs__item-active");
    }
    for (let tabsPage of tabsPages) {
      tabsPage.style.display = "none";
    }
    setTabPage1(false);
    setTabPage2(true);
    setTabPage3(false);
    tabs[1].classList.add("usefulPage-tabs__item-active");
    tabsPages[1].style.display = "block";
  };
  const tab3 = () => {
    for (let tab of tabs) {
      tab.classList.remove("usefulPage-tabs__item-active");
    }
    for (let tabsPage of tabsPages) {
      tabsPage.style.display = "none";
    }
    setTabPage1(false);
    setTabPage2(false);
    setTabPage3(true);
    tabs[2].classList.add("usefulPage-tabs__item-active");
    tabsPages[2].style.display = "block";
  };

  return (
    <>
      <Seo seo={context} />
      <div>
        <h1 className='usefulPage-title'>{context.title}</h1>
        <section className='section-useful how-banner'>
          <div className='how-banner-content'>
            <h2 className='how-banner-content-title'>{context.banner_title}</h2>

            <div
              className='how-banner-content-descr'
              dangerouslySetInnerHTML={{ __html: context.banner_text }}
            ></div>

            {tabPage1 && context.economy_video && (
              <a href='#video' className='how-gallery-button-useful'>
                <div className='how-gallery-button__play'>
                  <div className='how-gallery-button__play-inner'></div>
                </div>
                <div className='how-gallery-button__text'>
                  <div className='how-gallery-button__title'>
                    Смотреть видео
                  </div>
                </div>
              </a>
            )}
            {tabPage2 &&
              (context.buy_video === null ? null : (
                <a href='#video2' className='how-gallery-button-useful'>
                  <div className='how-gallery-button__play'>
                    <div className='how-gallery-button__play-inner'></div>
                  </div>
                  <div className='how-gallery-button__text'>
                    <div className='how-gallery-button__title'>
                      Смотреть видео
                    </div>
                  </div>
                </a>
              ))}
            {tabPage3 &&
              (context.select_video === null ? null : (
                <a href='#video3' className='how-gallery-button-useful'>
                  <div className='how-gallery-button__play'>
                    <div className='how-gallery-button__play-inner'></div>
                  </div>
                  <div className='how-gallery-button__text'>
                    <div className='how-gallery-button__title'>
                      Смотреть видео
                    </div>
                  </div>
                </a>
              ))}
          </div>
          <img loading="lazy"
            src={PICS_URL + context.banner_image}
            max-width='635px'
            max-height='314px'
            alt=''
          />
        </section>
        <section className='section-useful usefulPage-tabs'>
          <a
            onClick={tab1}
            className='usefulPage-tabs__item usefulPage-tabs__item-active'
          >
            <h2>Как сэкономить на упаковке?</h2>
          </a>
          <a onClick={tab2} className='usefulPage-tabs__item'>
            <h2>Как правильно закупить?</h2>
          </a>
          <a onClick={tab3} className='usefulPage-tabs__item'>
            <h2>Как выбрать поставщика?</h2>
          </a>
        </section>
        <section className='section-useful usefulPage-tabPage tabPage-js-1'>
          {isLoadedContext
            ? context.economy_items.map((item, i) => (
                <div key={i} className='usefulPage-gray'>
                  <h3 className='usefulPage-gray__title'>{item.title}</h3>
                  <p className='usefulPage-gray__descr'>{item.text}</p>
                </div>
              ))
            : null}
          <div className='usefulPage-table'>
            <div>
              <h3 className='usefulPage-table-title'>
                {context.economy_image_group_1_title}
              </h3>
              <div className='usefulPage-table-blocks'>
                <div className='usefulPage-table-blocks__item'>
                  <img loading="lazy"
                    src={PICS_URL + context.economy_image_group_1_image_1}
                    alt=''
                  />
                </div>
                <div className='usefulPage-table-blocks__item'>
                  <img loading="lazy"
                    src={PICS_URL + context.economy_image_group_1_image_2}
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div>
              <h3 className='usefulPage-table-title'>
                {context.economy_image_group_2_title}
              </h3>
              <div className='usefulPage-table-blocks'>
                <div className='usefulPage-table-blocks__item'>
                  <img loading="lazy"
                    src={PICS_URL + context.economy_image_group_2_image_1}
                    alt=''
                  />
                </div>
                <div className='usefulPage-table-blocks__item'>
                  <img loading="lazy"
                    src={PICS_URL + context.economy_image_group_2_image_2}
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
          {isLoadedContext
            ? context.economy_video !== null && (
                <section id='video' className='section-useful how-video'>
                  {/* превью для видео */}
                  <div className='mobile-how-video-title'>
                    Как выбрать воздушно-пузырьковую плёнку
                  </div>
                  <div className='how-video-img thumb1'>
                    <img loading="lazy" src={PICS_URL + context.economy_video.thumb} alt='' />
                    <div className='how-video-content-inner'>
                      <div className='how-video-title'>
                        Как выбрать воздушно-пузырьковую плёнку
                      </div>
                      <div onClick={playVideo} className='how-video-btn'>
                        <div className='how-video-btn-inner'></div>
                      </div>
                    </div>
                  </div>

                  {/* само видео */}
                  <div className='iFrame video1'>
                    <iframe
                      width='1078px'
                      height='606px'
                      src={videoUrls.economy}
                      rel='0'
                      autoPlay='1'
                      frameBorder='0'
                      allow='autoplay; encrypted-media'
                      allowFullScreen
                      title='video'
                    />
                  </div>
                </section>
              )
            : null}
        </section>
        <section
          className='section-useful usefulPage-tabPage tabPage-js-2'
          style={{ display: "none" }}
        >
          {isLoadedContext
            ? context.buy_items.map((item, i) => (
                <div key={i} className='usefulPage-gray'>
                  <h3 className='usefulPage-gray__title'>{item.title}</h3>
                  <p className='usefulPage-gray__descr'>{item.text}</p>
                </div>
              ))
            : null}
          <div className='usefulPage-tabPage-table'>
            <table className='usefulPage-tabPage-table__table'>
              <tbody>
                <tr>
                  <th className='table-heading'>{context.buy_table_title_1}</th>
                  <td className='table-subheading'>
                    {context.buy_table_title_2}
                  </td>
                  <td className='table-subheading'>
                    {context.buy_table_title_3}
                  </td>
                </tr>
                <tr>
                  <td
                    className='table-descr'
                    dangerouslySetInnerHTML={{
                      __html: context.buy_table_cell_1,
                    }}
                  ></td>
                  <td
                    className='table-descr'
                    dangerouslySetInnerHTML={{
                      __html: context.buy_table_cell_2,
                    }}
                  ></td>
                  <td
                    className='table-descr'
                    dangerouslySetInnerHTML={{
                      __html: context.buy_table_cell_3,
                    }}
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='how-algorithm'>
            <div className='how-algorithm-item-main'>
              <div>
                <div className='how-algorithm-preTitle'></div>
                <h1 className='how-algorithm-item-main-title'>
                  Алгоритм проверки
                </h1>
                <div className='how-algorithm-item-main-descr'>
                  Несколько простых шагов, чтобы понять честность бизнеса.
                  Проверьте, что Вы покупаете! Вероятно, Вас ждёт «сюрприз»!
                </div>
              </div>
              <div className='how-algorithm-item-main-avatar'>
                <div className='how-algorithm-item-main-avatar-img'></div>
                <div className='how-algorithm-item-main-avatar-text'>
                  <div className='algo-avatar-text-title'>Никита Котов</div>
                  <div className='algo-avatar-text-subtitle'>
                    Генеральный директор
                  </div>
                </div>
              </div>
            </div>
            {isLoadedContext
              ? context.algorithm_items.map((item, i) => (
                  <div key={i} className='how-algorithm-item'>
                    <h2 className='algo-title'>{item.title}</h2>
                    {/* <div className='algo-subtitle'>{item.description}</div> */}
                    <div className='algo-content'>
                      <div
                        className='algo-content-text'
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      ></div>
                      {item.image !== "" ? (
                        <div className='algo-content-icon'>
                          <img loading="lazy" src={PICS_URL + item.image} alt='' />
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))
              : null}
          </div>
          {isLoadedContext
            ? context.buy_video !== null && (
                <section id='video2' className='section-useful how-video'>
                  {/* превью для видео */}
                  <div className='how-video-img thumb2'>
                    <img loading="lazy" src={PICS_URL + context.buy_video.thumb} alt='' />
                    <div className='how-video-content-inner'>
                      <h1 className='how-video-title'>
                        Как выбрать воздушно-пузырьковую плёнку
                      </h1>
                      <div onClick={playVideo2} className='how-video-btn'>
                        <div className='how-video-btn-inner'></div>
                      </div>
                    </div>
                  </div>

                  {/* само видео */}
                  <div className='iFrame video2'>
                    <iframe
                      width='1078px'
                      height='606px'
                      src={videoUrls.buy}
                      rel='0'
                      autoPlay='1'
                      frameBorder='0'
                      allow='autoplay; encrypted-media'
                      allowFullScreen
                      title='video'
                    />
                  </div>
                </section>
              )
            : null}
        </section>
        <section
          className='section-useful usefulPage-tabPage tabPage-js-3'
          style={{ display: "none" }}
        >
          <div
            className='usefulPage-tabPage-text'
            dangerouslySetInnerHTML={{ __html: context.how_select }}
          ></div>
          {isLoadedContext
            ? context.select_items.map((item, i) => (
                <div key={i} className='usefulPage-gray'>
                  <h3 className='usefulPage-gray__title'>{item.title}</h3>
                  <div
                    className='usefulPage-gray__descr'
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  ></div>
                </div>
              ))
            : null}
          {isLoadedContext
            ? context.select_video !== null && (
                <section id='video3' className='section-useful how-video'>
                  {/* превью для видео */}
                  <div className='how-video-img thumb3'>
                    <img loading="lazy" src={PICS_URL + context.select_video.thumb} alt='' />
                    <div className='how-video-content-inner'>
                      <h1 className='how-video-title'>
                        Как выбрать воздушно-пузырьковую плёнку
                      </h1>
                      <div onClick={playVideo3} className='how-video-btn'>
                        <div className='how-video-btn-inner'></div>
                      </div>
                    </div>
                  </div>

                  {/* само видео */}
                  <div className='iFrame video3'>
                    <iframe
                      width='1078px'
                      height='606px'
                      src={videoUrls.select}
                      rel='0'
                      autoPlay='1'
                      frameBorder='0'
                      allow='autoplay; encrypted-media'
                      allowFullScreen
                      title='video'
                    />
                  </div>
                </section>
              )
            : null}
        </section>
      </div>
    </>
  );
}

export default UsefulComponent;
